import { ReactNode } from "react";
import "./PulsingCircle.scss";

interface PulsingCircleProps {
  children: ReactNode;
}

/**
 * Two large concentric purple glow rings that breathe while recording.
 * Outer ring: 5× button size (~500%). Inner ring: 3.2× (~320%).
 * Matches Figma 318-9542: Ellipse32 (700px) + Ellipse31 (450px) around 140px button.
 */
function PulsingCircle({ children }: PulsingCircleProps) {
  return (
    <span className="pulsing">
      <span className="pulsing__outer" />
      <span className="pulsing__inner" />
      <span className="pulsing__child">{children}</span>
    </span>
  );
}

export default PulsingCircle;
